const crypto = require('crypto');
const isProd = process.env.VUE_APP_PROD;
const key = isProd === 'true'
              ? 's5u8x/A?D(G+KbPeShVmYq3t6w9y$B&E' 
              : '7w9z$C&F)J@NcRfUjXn2r5u8x/A%D*G-';

function encrypt(text) {
  const iv = crypto.randomBytes(16);
  let cipher = crypto.createCipheriv('aes-256-cbc', Buffer.from(key), iv);
  let encrypted = cipher.update(text);
  encrypted = Buffer.concat([encrypted, cipher.final()]);

  return {
      iv: iv.toString('hex'),
      encryptedData: encrypted.toString('hex')
  };
}


function decrypt(encryptedData, iv) {
  try {
    let decipher = crypto.createDecipheriv('aes-256-cbc', Buffer.from(key), Buffer.from(iv, 'hex'));
    let decrypted = decipher.update(Buffer.from(encryptedData, 'hex'));
    decrypted = Buffer.concat([decrypted, decipher.final()]);
    return decrypted.toString();
  } catch (err) {
    console.error(err.message + ` with key: ${key.toString('hex')}`);
    return null;
  }
}

export { encrypt, decrypt };

